import { ScoreManager } from '../storage/ScoreManager';

export class Menu {
  private container: HTMLElement;
  private onStart: (playerCount: number) => void;
  private scoreManager: ScoreManager;

  constructor(
    container: HTMLElement,
    scoreManager: ScoreManager,
    onStart: (playerCount: number) => void
  ) {
    this.container = container;
    this.scoreManager = scoreManager;
    this.onStart = onStart;

    this.render();
    this.setupKeyboard();
  }

  private selectedCombatants: number = 8;

  render(statusMessage: string = ''): void {
    const scores = this.scoreManager.getScores();
    const highlightRank = this.scoreManager.highlightRank;
    const highlightValue = this.scoreManager.highlightValue;

    let scoresHtml = '';
    for (let i = 0; i < 10; i++) {
      if (i < scores.length) {
        const val = scores[i].toLocaleString();
        const isHighlighted = highlightRank === i && scores[i] === highlightValue;
        scoresHtml += `<div class="score-row ${isHighlighted ? 'highlight' : ''}">
          <span class="score-rank">#${i + 1}</span>
          <span class="score-val">${val}</span>
        </div>`;
      } else {
        scoresHtml += `<div class="score-row empty">
          <span class="score-rank">#${i + 1}</span>
          <span class="score-val">---</span>
        </div>`;
      }
    }

    const options = [
      { val: 2, label: '2 (1v1 Boss Duel)' },
      { val: 3, label: '3 (Triangle Arena)' },
      { val: 4, label: '4 (Square Arena)' },
      { val: 5, label: '5 (Pentagon Arena)' },
      { val: 6, label: '6 (Hexagon Arena)' },
      { val: 7, label: '7 (Heptagon Arena)' },
      { val: 8, label: '8 (Octagon Battle Royale)' },
    ];
    const optionsHtml = options
      .map(
        o =>
          `<option value="${o.val}" ${o.val === this.selectedCombatants ? 'selected' : ''}>${o.label}</option>`
      )
      .join('');

    this.container.innerHTML = `
      <div class="menu-card">
        <div class="brand-badge">BATTLE ROYALE ARCADE</div>
        <h1 class="game-title">POLYPONG</h1>

        ${statusMessage ? `<div class="status-alert" id="statusMessage">${statusMessage}</div>` : ''}

        <div class="high-scores-panel">
          <div class="panel-header">
            <span>HALL OF FAME (TOP 10)</span>
            <span class="trophy-icon">🏆</span>
          </div>
          <div class="scores-grid">${scoresHtml}</div>
        </div>

        <div class="menu-form">
          <label for="playerCount" class="input-label">SELECT COMBATANTS</label>
          <div class="select-wrapper">
            <select id="playerCount" class="cyber-select">
              ${optionsHtml}
            </select>
          </div>

          <button id="start-btn" class="cyber-button primary-glow">
            <span class="btn-text">START BATTLE</span>
            <span class="btn-key">[SPACE]</span>
          </button>
        </div>

        <div class="controls-guide">
          <div class="guide-item"><kbd>A</kbd> / <kbd>D</kbd> Move Paddle</div>
          <div class="guide-item"><kbd>Q</kbd> / <kbd>E</kbd> Tilt Paddle Deflect</div>
          <div class="guide-item"><kbd>W</kbd> Golden Smash (When Charged)</div>
        </div>
      </div>
    `;

    const startBtn = document.getElementById('start-btn');
    const select = document.getElementById('playerCount') as HTMLSelectElement;

    if (select) {
      select.addEventListener('change', () => {
        this.selectedCombatants = parseInt(select.value, 10) || 8;
      });
    }

    if (startBtn && select) {
      startBtn.addEventListener('click', () => {
        const count = parseInt(select.value, 10) || 8;
        this.selectedCombatants = count;
        this.onStart(count);
      });
    }
  }

  show(statusMessage: string = ''): void {
    this.render(statusMessage);
    this.container.style.display = 'flex';
  }

  hide(): void {
    this.container.style.display = 'none';
  }

  private setupKeyboard(): void {
    window.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.code === 'Space' || e.key === ' ' || e.key === 'Spacebar') {
        const isMenuVisible = window.getComputedStyle(this.container).display !== 'none';
        if (isMenuVisible) {
          const tag = (e.target as HTMLElement)?.tagName?.toLowerCase();
          if (tag === 'input' || tag === 'textarea') return;

          e.preventDefault();
          const select = document.getElementById('playerCount') as HTMLSelectElement;
          const count = select ? parseInt(select.value, 10) || 8 : this.selectedCombatants;
          this.selectedCombatants = count;
          this.onStart(count);
        }
      }
    });
  }
}
